import { isNumber } from '../lib/helpers';

import APIClient from './APIClient';

const {
  REACT_APP_ONBOARDING_API_HOST: ONBOARDING_API_HOST,
  REACT_APP_CAP_ON_LOAN_ENDPOINT: CAP_ON_LOAN_ENDPOINT,
  REACT_APP_CALCULATE_CAP_ON_LOAN_ENDPOINT: CALCULATE_CAP_ON_LOAN_ENDPOINT,
} = process.env;

export const urlFor = periodGuid =>
  `${ONBOARDING_API_HOST}${CAP_ON_LOAN_ENDPOINT}`.replace('{periodGuid}', periodGuid);

export const calculateUrl = `${ONBOARDING_API_HOST}${CALCULATE_CAP_ON_LOAN_ENDPOINT}`;

const safeParse = floatValue => (isNumber(floatValue) ? parseFloat(floatValue) : null);

export default class CapOnLoanAPI {
  static maximumLoanAmountFor = (periodGuid, token, params) => {
    return APIClient.get(urlFor(periodGuid), token, { params }).then(response => response.data);
  };

  static calculateMaximumLoanAmount = (params, token) => {
    return APIClient.post(calculateUrl, params, token).then(response => response.data);
  };

  static paramsFrom = otherFunds => {
    const { scholarship, sponsorship, loans } = otherFunds;

    return {
      otherFundsScholarshipPeriodAmount: safeParse(scholarship.period.amount),
      otherFundsSponsorshipPeriodAmount: safeParse(sponsorship.period.amount),
      otherFundsLoansPeriodAmount: safeParse(loans.period.amount),
      otherFundsScholarshipRemainderPeriodAmount: safeParse(scholarship.remainder.amount),
      otherFundsSponsorshipRemainderPeriodAmount: safeParse(sponsorship.remainder.amount),
      otherFundsLoansRemainderPeriodAmount: safeParse(loans.remainder.amount),
    };
  };
}
